import {
  HANDLE_CHANGE_DADOS_RENDA_MENSAL,
  HANDLE_CHANGE_DADOS_PATRIMONIO,

  CHANGE_DECLARACAO_PF_VALUE_FORM,
  CHANGE_DECLARACAO_PJ_VALUE_FORM,
  HANDLE_CHANGE_DECLARACAO_SOU_PESSOA_FLAG,
  HANDLE_CHANGE_DECLARACAO_RELACIONAMENTO_FLAG,
  HANDLE_CHANGE_DECLARACAO_SOCIO_FLAG,
  HANDLE_CHANGE_DECLARACAO_FATCA_FLAG,
  HANDLE_CHANGE_DECLARACAO_PERSON_FLAG,
  HANDLE_CHANGE_DECLARACAO_OPERACAO_IMPORTACAO,
  HANDLE_CHANGE_PESSOA_AMERICANA,
  CHANGE_DECLARACAO_NIF,
  HANDLE_CHANGE_DADOS_NIF_COUNTRY,
  FILL_PROFESSION_LIST,
  SET_LISTA_DECLARACAO_ANUAL,
  HANDLE_CHANGE_DECLARACAO_ANUAL
} from './types';

const initialState = {

  formDeclaracaoPF: {
    declaracoesEspecificasObrigatorias_ocupacaoPrincipal: '',
    declaracoesEspecificasObrigatorias_faixaRendaMensal: '',
    declaracoesEspecificasObrigatorias_faixaPatrimonio: ''
  },

  formDeclaracaoPJ: {
    declaracoesEspecificasObrigatorias_participanteGiin: '',    
  },

  declaracoesEspecificasObrigatorias_ppe: false,
  declaracoesEspecificasObrigatorias_relacaoPessoaPpe: false,
  declaracoesEspecificasObrigatorias_socioPpe: false,
  declaracoesEspecificasObrigatorias_operacaoImportacao: false,
  declaracoesEspecificasObrigatorias_participanteFatca: false,
  declaracoesEspecificasObrigatorias_pessoaAmericana: null,

  declaracoesEspecificasObrigatorias_nif: '',
  declaracoesEspecificasObrigatorias_nifCountry: '',
  declaracoesEspecificasObrigatorias_listaProfissao: [],
  declaracoesEspecificasObrigatorias_declaracaoAnual: '',
  dropdownDeclaracaoAnualList: []
}


export default function declaracaoEspecificaReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_DECLARACAO_NIF:
      return {...state, declaracoesEspecificasObrigatorias_nif: action.payload}

    case FILL_PROFESSION_LIST:
      return {...state, declaracoesEspecificasObrigatorias_listaProfissao: action.payload}

    case HANDLE_CHANGE_DADOS_NIF_COUNTRY:
      return {...state, declaracoesEspecificasObrigatorias_nifCountry: action.payload}

    case HANDLE_CHANGE_PESSOA_AMERICANA:
      return {...state, declaracoesEspecificasObrigatorias_pessoaAmericana: action.payload}
      
    case CHANGE_DECLARACAO_PF_VALUE_FORM:
      return { ...state, formDeclaracaoPF: action.payload }

    case CHANGE_DECLARACAO_PJ_VALUE_FORM:
      return { ...state, formDeclaracaoPJ: action.payload }

    case HANDLE_CHANGE_DECLARACAO_SOU_PESSOA_FLAG:
      return { ...state, declaracoesEspecificasObrigatorias_ppe: action.payload }

    case HANDLE_CHANGE_DECLARACAO_RELACIONAMENTO_FLAG:
      return { ...state, declaracoesEspecificasObrigatorias_relacaoPessoaPpe: action.payload }

    case HANDLE_CHANGE_DECLARACAO_OPERACAO_IMPORTACAO:
      return { ...state, declaracoesEspecificasObrigatorias_operacaoImportacao: action.payload }

      case HANDLE_CHANGE_DECLARACAO_SOCIO_FLAG:
      return { ...state, declaracoesEspecificasObrigatorias_socioPpe: action.payload }

    case HANDLE_CHANGE_DECLARACAO_FATCA_FLAG:
      return { ...state, declaracoesEspecificasObrigatorias_participanteFatca: action.payload }

    case HANDLE_CHANGE_DECLARACAO_PERSON_FLAG:
      return { ...state, declaracoesEspecificasObrigatorias_pessoaAmericana: action.payload }

    case HANDLE_CHANGE_DADOS_RENDA_MENSAL:
      return { ...state, declaracoesEspecificasObrigatorias_faixaRendaMensal: action.payload }

    case HANDLE_CHANGE_DADOS_PATRIMONIO:
      return { ...state, declaracoesEspecificasObrigatorias_faixaPatrimonio: action.payload }
    case SET_LISTA_DECLARACAO_ANUAL:
        return { ...state, dropdownDeclaracaoAnualList: action.payload }
    case HANDLE_CHANGE_DECLARACAO_ANUAL:
      return { ...state, declaracoesEspecificasObrigatorias_declaracaoAnual: action.payload }
    default:
      return state
  }
}